<template>
	<div class="">
        <div class="coachee_status coachee_detail_page">
            <div class="row page-heading mx-0">
                <div class="col-8 input module_heading">
                    <span class="module_icon icon-user" style="color: #157099;"></span>
                    <span class="module_type_name">Subscriber Status</span>
                </div>
                <div class="col-4 submit btn-container text-right">
                </div>
            </div>

			<div class="data_row_container">

				<div class="row data_row">
				
					<div class="container_row">
					
						<div class="username_and_progress_container">

							<div class="user_detail">
								<div class="thumbnail">
									<div class="icon icon-user"></div>
								</div>
								<div class="username_section">
									<span class="username">{{user.userName}}</span>
                 					<span v-if="showReminderWarning" class="exclamation-circle" v-b-popover.hover="'You have a reminder!'">
                 						<span class="ico-error"></span>
                 					</span>
								</div>
								<div class="invite-msg" style="visibility:hidden;">
	                                <span>(Invite Sent <i class="fas fa-check"></i>)</span>
								</div>
							</div>

							<div class="progress-bar-sec">
								<div class="count-value" v-if="completedQuests === 0">0</div>
                                <div class="count-value" v-else>{{completedQuests}}</div>
                                <div class="progress"></div>
						        <b-progress-bar :max="userQuests.length" :value="completedQuests"></b-progress-bar>
							</div>

						</div>

						<div class="quest_details_container">

							<!--
							<div class="quest_row">
								Start Date : Apr 10, 2019
							</div>
							-->

							<div class="quest_row">
								<span class="quest_col">
									<span class="ic icon-job"></span>
									<span class="count-title">
										<span class="count">{{careerIdeaCount}}</span>
										<span class="title">Career Idea</span>
									</span>
								</span>
								<span class="quest_col">
									<span class="ic ico-connection1"></span>
									<span class="count-title">
										<span class="count">{{connectionCount}}</span>
										<span class="title">Connection</span>
									</span>
								</span>
								<span class="quest_col">
									<span class="ic ico-conversation"></span>
									<span class="count-title">
										<span class="count">{{conversationCount}}</span>
										<span class="title">Conversations</span>
									</span>
								</span>
							</div>

						</div>
						
						<div class="current_quest_details">
							<div id="questTitlePopover" class="quest-title-popover"></div>
							<div class="current_quest_width">
								<div class="quest_row current_quest" v-if="this.currentQuest">
									<span class="label">Current Quest: </span>
									<span class="ico-continue"></span>
									<span id="questTitle" class="val">{{currentQuest}}</span>
									<b-popover target="questTitle" :title="currentQuest" container="questTitlePopover" triggers="hover focus"></b-popover>
								</div>
							</div>
						</div>

						<div class="current_quest_details">
							<div class="current_quest_width">
								<div class="quest_row current_quest" v-if="this.currentQuest">
									<span class="label">Current Quest: </span>
									<span class="ico-continue"></span>
									<span id="questTitle" class="val">{{currentQuest}}</span>
								</div>
							</div>
						</div>

						<div class="float-right mt-2 mr-4">
                            <b-button @click="back" variant="primary" class="back-button">hide details</b-button>
						</div>

					</div>
					<div class="tabs-container">
				          <b-tabs>
				            <b-tab title="Quests">
									       <div class="quest_block_container list_view display-block">

							            <template v-for="quest in userQuests">
							              	<div class="quest_status_block row" :class="statusClass(quest.status)">
				    			              		<div class="col-5">
				    				              		<div class="quest_name" @click="generateReport(quest, user.userName, $event.target)">
				    				              			<span v-if="quest.status === -1" class="ic ico-lock"></span>
															<span v-if="quest.status === 1" style="color: #1e7296;" class="ic ico-continue"></span>
				    				  						<div v-if="quest.status === 1" style="color: #c5a112;">{{quest.titleForStudent}}</div>
				    				  						<div v-if="quest.status === 2" style="color: rgb(79, 143, 0);">{{quest.titleForStudent}}</div>
				    				  						<div v-if="quest.status === -1">{{quest.titleForStudent}}</div>
				    				  						<div v-if="quest.status === 0">{{quest.titleForStudent}}</div>
				    				  					</div>
				    				  					<div class="status second_row">
				    			  							<span class="label">Status: </span>
				    			  							<span class="val">
				    				  							<span v-if="quest.status === -1">Locked</span>
				    				  							<span v-if="quest.status === 0">Unlocked</span>
				    				  							<span v-if="quest.status === 1">In-Progress</span>
				    				  							<span v-if="quest.status === 2">Done</span>
				    			  							</span>
				    			  						</div>
				    			              		</div>

				    			  					<div class="col-3">
				    			  						<div v-if="quest.status === -1">
				    				  						<div class="date">
				    				  							<span class="icon ico-dateRange"></span>
				    				  							<span class="label">Unlocked:</span>
				    				  							<span class="no_val">xx/xx/xxxx</span>
				    				  						</div>
				    				  						<div class="date second_row">
				    				  							<span class="icon ico-dateRange"></span>
				    				  							<span class="label">Started:</span>
				    				  							<span class="no_val">xx/xx/xxxx</span>
				    				  						</div>
				    				  						<div class="date third_row">
				    				  							<span class="icon ico-dateRange"></span>
				    				  							<span class="label">Completed:</span>
				    				  							<span class="no_val">xx/xx/xxxx</span>
				    				  						</div>
				    			  						</div>

				    			  						<div v-if="quest.status === 0">
				    				  						<div class="date">
				    				  							<span class="icon ico-dateRange"></span>
				    				  							<span class="label">Unlocked:</span>
				    				  							<template v-if="quest.unlockedTime > 0">
				    				  							   <span class="val">{{changeMillisToDate(quest.unlockedTime)}}</span>
				    				  							</template>
				    				  							<template v-else>
				    				  							   <span class="no_val">xx/xx/xxxx</span>
				    				  							</template>
				    				  						</div>
				    				  						<div class="date second_row">
				    				  							<span class="icon ico-dateRange"></span>
				    				  							<span class="label">Started:</span>
				    				  							<span class="no_val">xx/xx/xxxx</span>
				    				  						</div>
				    				  						<div class="date third_row">
				    				  							<span class="icon ico-dateRange"></span>
				    				  							<span class="label">Completed:</span>
				    				  							<span class="no_val">xx/xx/xxxx</span>
				    				  						</div>
				    			  						</div>

				    			  						<div v-if="quest.status === 1">
				    				  						<div class="date">
				    				  							<span class="icon ico-dateRange"></span>
				    				  							<span class="label">Unlocked:</span>
				    				  							<template v-if="quest.unlockedTime > 0">
                                                                   <span class="val">{{changeMillisToDate(quest.unlockedTime)}}</span>
                                                                </template>
                                                                <template v-else>
                                                                   <span class="no_val">xx/xx/xxxx</span>
                                                                </template>
				    				  						</div>
				    				  						<div class="date second_row">
				    				  							<span class="icon ico-dateRange"></span>
				    				  							<span class="label">Started:</span>
				    				  							<template v-if="quest.startTime > 0">
                                                                   <span class="val">{{changeMillisToDate(quest.startTime)}}</span>
                                                                </template>
                                                                <template v-else>
                                                                   <span class="no_val">xx/xx/xxxx</span>
                                                                </template>
				    				  						</div>
				    				  						<div class="date third_row">
				    				  							<span class="icon ico-dateRange"></span>
				    				  							<span class="label">Completed:</span>
				    				  							<span class="no_val">xx/xx/xxxx</span>
				    				  						</div>
				    			  						</div>

				    			  						<div v-if="quest.status === 2">
				    				  						<div class="date">
				    				  							<span class="icon ico-dateRange"></span>
				    				  							<span class="label">Unlocked:</span>
				    				  							<template v-if="quest.unlockedTime > 0">
                                                                   <span class="val">{{changeMillisToDate(quest.unlockedTime)}}</span>
                                                                </template>
                                                                <template v-else>
                                                                   <span class="no_val">xx/xx/xxxx</span>
                                                                </template>
				    				  						</div>
				    				  						<div class="date second_row">
				    				  							<span class="icon ico-dateRange"></span>
				    				  							<span class="label">Started:</span>
				    				  							<template v-if="quest.startTime > 0">
                                                                   <span class="val">{{changeMillisToDate(quest.startTime)}}</span>
                                                                </template>
                                                                <template v-else>
                                                                   <span class="no_val">xx/xx/xxxx</span>
                                                                </template>
				    				  						</div>
				    				  						<div class="date third_row">
				    				  							<span class="icon ico-dateRange"></span>
				    				  							<span class="label">Completed:</span>
				    				  							<template v-if="quest.endTime > 0">
                                                                   <span class="val">{{changeMillisToDate(quest.endTime)}}</span>
                                                                </template>
                                                                <template v-else>
                                                                   <span class="no_val">xx/xx/xxxx</span>
                                                                </template>
				    				  						</div>
				    			  						</div>
				    			  					</div>

				    			  					<div class="col-2">
				    			  					</div>

				    			  					<div class="col-2">

				    			                	</div>
				    			  				</div>
							            </template>
									       </div> <!-- .quest_block_container -->
				            </b-tab>
				            <b-tab title="Career Ideas">

				              <div class="quest_block_container list_view display-block module_section">
							     <template v-if="careerIdeas && careerIdeas.length > 0">

					                <div v-for="careerIdea in careerIdeas" class="tab_data_row_container">

					                    <div class="row data_row content-row">
											<div class="title col-3 col_lg">
												<!--
												<div class="thumbnail-section" v-b-popover.hover.top="careerIdea.title" variant="primary">
													<div class="icon icon-job"></div>
												</div>
												-->
												<div class="col_title" style="padding-top: 0px;">
													{{careerIdea.title}}
												</div>
											</div><!--closed title-->

											<div class="second-col col-3 col_lg">
												<div class="label">Interest: </div>
												<div class="interest_level">
													<span class="selection-label" v-if="careerIdea.interestLevel === '1'">High</span>
												    <span class="selection-label" v-if="careerIdea.interestLevel === '2'">Medium</span>
												    <span class="selection-label" v-if="careerIdea.interestLevel === '3'">Low</span>
												</div>
											</div> <!--closed second col-->

											<!--
											<div class="third-col col-3 col_sm col-connection">
												<div style="float: left; width: 100%;">
													<div class="sec_row" style="margin-top: 1px; float: left; width: 100%; height: 40px;">
														<div class="icon-col" aria-label="connection list" style="height: 40px;">
															<span class="icon ico-connection1"></span>
															<span class="count-col"><span>{{careerIdea.connectionCount}}</span> Connection</span>
														</div>
													</div>
												</div>
											</div>
											-->
											<!--close third col-->


                                          <div class="third-col col-3 col_sm col-connection">
                                              <div class="sec_row" style="margin-top: 2px; float: left; width: 100%; height: 40px;">
														<div class="icon-col" style="height: 40px;">
															<span class="icon ico-conversation"></span>
															<span class="count-col"><span>{{careerIdea.conversationCount}}</span> Conversation</span>
														</div>
													</div>
                                          </div><!--close Fourth col-->
									   </div><!--closed data row-->

									   <div class="connections_section" v-if="connectionsReady && careerIdea.connections && careerIdea.connections.length > 0">
                     						<h5 style="float: left; width: 100%;">
                     							<span class="icon ico-connection1" style="font-size: 30px; float: left;"></span>
                     							<span class="count-col" style="float: left; margin-top: 1px; margin-left: 6px;">{{careerIdea.connectionCount}} Connection(s)</span>
                     						</h5>
                     						<template v-if="connectionsReady" v-for="connection in careerIdea.connections">
												<div class="row data_row content-row">
													<b-link class="title col-3" @click="generateConversationReport(connection, user.userName)" style="margin-left: 10px;">
														<!--
														<span class="thumbnail-section">
															<div class="icon ico-connection1"></div>
														</span>
														-->
														<span class="col_title">
															{{connection.firstName}} {{connection.lastName}}
														</span>
													</b-link><!--closed title-->
													<span class="col-6 curr-org">
                                                        <template v-if="connection.organization">
                                                            <span>Organization: {{connection.organization}}</span>
                                                        </template>
                                                    </span>
                                                    <span class="col-2 meetingdates">
                                                        <template v-if="connection.meetingDate">
                                                            <span>Meeting Date: {{changeMillisToDate(connection.meetingDate)}}</span>
                                                        </template>
                                                    </span>
										   		</div><!--closed data row-->
									   		</template>
										</div>

					                </div>
					             </template>
					             <template v-else class="no-result">
                                      <div class="no_data_msg">
                                          <span>0 Career Ideas</span>
                                      </div>
                                 </template>
				              </div> <!-- .quest_block_container -->

				            </b-tab>
				            <b-tab title="Notes">
				            	<div class="row page-heading">
				            		<div class="col-7 module_heading"></div>
				            		<div class="col-5 float-right px-0">
				            			<div class="submit btn-container">
                              				<button class="btn btn-primary" @click="clearReminder" aria-label="save">clear reminder</button>
                              				<button class="btn btn-primary" @click="saveReminder" aria-label="save">save reminder</button>
                              				<button class="btn btn-primary" @click="saveNote" aria-label="save">save note</button>
				            			</div>
				            		</div>
				            	</div>
				            	<div class="row content-row">
				            		<div class="row col-6 note-row">
					            		<div class="col-3 label">Note:</div>
										<div class="col-9"><textarea v-model="note"></textarea></div>
									</div>
									<div class="row col-6">

										<div class="row col-12 cont-row">
											<div class="col-3 label">Meeting Date:</div>
											<div class="col-9">
											   <datetime
								                  type="date" v-model="reminderDate" zone="utc"
								                  :format="{year: 'numeric', month: '2-digit', day: '2-digit'}"
		                             			  :week-start="7" input-style="width: 100%; height: 34px;" auto>
								               </datetime>
								            </div>
										</div>

										<div class="row col-12 cont-row">
											<div class="col-3 label">Reminder:</div>
											<div class="col-9"><textarea v-model="reminder"></textarea></div>
										</div>

									</div>
				            	</div>

				            </b-tab>
				          </b-tabs>
				     </div>
				</div> <!-- .data_row -->

			</div>

		</div>
        <b-modal class="page_modal" id="mainQuestReportInfo" size="xlg" centered :title="mainQuestReportTitle" @hidden="showAttemptReport = false" hide-footer>
			<template v-if="showAttemptReport">
				<div slot="modal-header" class="header-section">
					<div class="popup-heading">{{mainQuestReportTitle}}</div>
						<button class="btn_close" aria-label="close" @click="closeAttemptReport">
                           <span class="ic-close"></span>
                        </button>
				</div>

				<div class="popup_inner_content">
					<class-activity-outcome :activity-outcome-parameter="activityOutcomeParameter"></class-activity-outcome>
				</div>
			</template>
		</b-modal>

		<b-modal class="page_modal" id="conversationQuestReportInfo" size="xlg" centered :title="conersationQuestReportTitle" @hidden="showConversationReport = false" hide-footer>
            <template v-if="showConversationReport">
                <div slot="modal-header" class="header-section">
                    <div class="popup-heading">{{conersationQuestReportTitle}}</div>
                       <button class="btn_close" aria-label="close" @click="closeConversationReport">
                          <span class="ic-close"></span>
                       </button>
                </div>

                <div class="popup_inner_content">
                    <conversation-quest-report :worksheet-parameter="worksheetParameter" :scorecard-parameter="scorecardParameter"></conversation-quest-report>
                </div>
            </template>
        </b-modal>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ClassActivityOutcome from '../../assessment/components/ClassActivityOutcome'
import ConversationQuestReport from '../../assessment/components/ConversationQuestReport'
import { DateTime } from 'luxon'
import { Datetime } from 'vue-datetime'

export default {
  name: 'CoacheeDetail',
  props: ['uuid', 'user', 'careerIdeaCount', 'connectionCount', 'conversationCount'],
  components: {
    Datetime,
    ClassActivityOutcome,
    ConversationQuestReport
  },
  data: () => {
    return {
      quests: [],
      careerIdeas: [],
      connections: {},
      completedQuests: 0,
      currentQuest: '',
      userQuests: [],
      showAttemptReport: false,
      activityOutcomeParameter: {},
      mainQuestReportTitle: '',
      note: '',
      reminder: '',
      reminderDate: '',
      showReminderWarning: false,
      connectionsReady: false,
      conersationQuestReportTitle: '',
      showConversationReport: false,
      worksheetParameter: {},
      scorecardParameter: {}
    }
  },

  mounted () {
    this.loadCoacheeDetail()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadCoacheeStatus',
      'loadCoachees',
      'loadUnlockQuest',
      'loadCareerIdeasForUser',
      'loadConnections',
      'loadSaveNote',
      'loadNote',
      'loadAssessmentAttemptForClass'
    ]),
    back () {
      return this.$router.push({ name: 'coacheeTracker' })
    },
    loadCoacheeDetail () {
      if (!this.uuid || !this.user) {
        return this.$router.push({ name: 'coacheeTracker' })
      }
      this.loadCareerIdeasForUser({userId: this.uuid, index: 0}).then(res => {
        this.careerIdeas = res.data
        this.loadCareerIdeaConnections()
      })
      this.loadCoacheeStatus().then(res => {
        this.quests = res
        this.loadCoacheeQuests()
      })
      this.loadNote({coacheeId: this.uuid, type: 'note'}).then(res => {
        if (res) {
          this.note = res.note
        }
      })
      this.loadNote({coacheeId: this.uuid, type: 'reminder'}).then(res => {
        if (res) {
          this.reminder = res.note
          this.reminderDate = res.reminderDate
          var today = new Date()
          var reminderDateTemp = new Date(this.reminderDate)
          if (reminderDateTemp.getTime() <= today.getTime()) {
            this.showReminderWarning = true
          }
        }
      })
    },
    loadCoacheeQuests () {
      for (var i = 0; i < this.quests.length; i++) {
        var currentQ = this.quests[i]
        if (currentQ.userId !== this.uuid) {
          continue
        }

        if ((currentQ.status >= 2) && (currentQ.order > 1)) {
          this.completedQuests += 1
          this.currentQuest = currentQ.titleForStudent
        }

        if (currentQ.status === 1) {
          this.currentQuest = currentQ.titleForStudent
        }
        this.userQuests.push(currentQ)
      }
    },
    async loadCareerIdeaConnections () {
      for (var i = 0; i < this.careerIdeas.length; i++) {
        var currentCI = this.careerIdeas[i]
        await this.loadConnections(currentCI.uuid).then(res => {
          if (res && res.length > 0) {
            this.connections[res[0].careerIdeaId] = res
          }
          return res
        })
        this.careerIdeas[i].connections = this.connections[this.careerIdeas[i].uuid]
      }
      this.connectionsReady = true
    },
    statusClass (status) {
      if (status === -1) {
        return 'status_locked'
      } else if (status === 0) {
        return 'status_unlocked'
      } else if (status === 1) {
        return 'status_in_progress'
      } else { // 2 or 3
        return 'status_done'
      }
    },
    unlockQuest (userId, courseId, entityId) {
      this.loadUnlockQuest({userId: userId, courseId: courseId, contentId: entityId}).then((res) => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Quest Successfully Unlocked!'
        })
        this.resetData()
        this.loadCoacheeDetail()
      })
    },
    resetData () {
      this.quests = []
      this.userQuests = []
    },
    generateReport (quest, userName) {
      let user = {}
      user[quest.userId] = userName
      let users = [user]
      this.loadAssessmentAttemptForClass({assessmentId: quest.entityId, users: users}).then(res => {
        if (res && res.length > 0 && res[0].attempt1) {
          this.showAttemptReport = true
          this.activityOutcomeParameter['userId'] = res[0].userId
          this.activityOutcomeParameter['courseId'] = quest.courseId
          this.activityOutcomeParameter['sessionId'] = res[0].attempt1.sessionId
          this.activityOutcomeParameter['activityId'] = res[0].attempt1.activityId
          this.activityOutcomeParameter['manuallyGraded'] = res[0].attempt1.manuallyGraded
          if (res[0].attempt1.isCompleted) {
            this.activityOutcomeParameter['isCompleted'] = res[0].attempt1.isCompleted
          } else {
            this.activityOutcomeParameter['isCompleted'] = (res[0].attempt1.status === 2)
          }
          this.mainQuestReportTitle = 'Quest Report - ' + res[0].name
          this.$root.$emit('bv::show::modal', 'mainQuestReportInfo', null)
        }
      })
    },
    closeAttemptReport () {
      this.$root.$emit('bv::hide::modal', 'mainQuestReportInfo')
    },
    generateConversationReport (connection, userName) {
      let user = {}
      user[connection.createdBy] = userName
      let users = [user]
      this.worksheetParameter = {}
      this.scorecardParameter = {}
      this.loadAssessmentAttemptForClass({assessmentId: connection.conversationQuestId, users: users}).then(worksheetRes => {
        this.conersationQuestReportTitle = 'Conversation Quest Report - ' + userName
        if (worksheetRes && worksheetRes.length > 0 && worksheetRes[0].attempt1) {
          this.worksheetParameter['userId'] = worksheetRes[0].userId
          this.worksheetParameter['courseId'] = connection.mainCourseId
          this.worksheetParameter['sessionId'] = worksheetRes[0].attempt1.sessionId
          this.worksheetParameter['status'] = worksheetRes[0].attempt1.status
          if (worksheetRes[0].attempt1.isCompleted) {
            this.worksheetParameter['isCompleted'] = worksheetRes[0].attempt1.isCompleted
          } else {
            this.worksheetParameter['isCompleted'] = (worksheetRes[0].attempt1.status === 2)
          }
          this.loadAssessmentAttemptForClass({assessmentId: connection.ratingQuestId, users: users}).then(scorecardRes => {
            if (scorecardRes && scorecardRes.length > 0 && scorecardRes[0].attempt1) {
              this.scorecardParameter['sessionId'] = scorecardRes[0].attempt1.sessionId
              this.scorecardParameter['status'] = scorecardRes[0].attempt1.status
              if (scorecardRes[0].attempt1.isCompleted) {
                this.scorecardParameter['isCompleted'] = scorecardRes[0].attempt1.isCompleted
              } else {
                this.scorecardParameter['isCompleted'] = (scorecardRes[0].attempt1.status === 2)
              }
            } else {
              this.scorecardParameter['status'] = 0
              this.scorecardParameter['isCompleted'] = false
            }
            this.showConversationReport = true
            this.$root.$emit('bv::show::modal', 'conversationQuestReportInfo', null)
          })
        } else {
          this.worksheetParameter['status'] = 0
          this.worksheetParameter['isCompleted'] = false
          this.scorecardParameter['status'] = 0
          this.scorecardParameter['isCompleted'] = false
          this.showConversationReport = true
          this.$root.$emit('bv::show::modal', 'conversationQuestReportInfo', null)
        }
      })
    },
    closeConversationReport () {
      this.$root.$emit('bv::hide::modal', 'conversationQuestReportInfo')
    },
    saveNote () {
      var saveNote = {
        note: this.note,
        coacheeUuid: this.uuid,
        type: 'note'
      }
      this.loadSaveNote(saveNote).then(res => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Note Successfully Saved!'
        })
      })
    },
    saveReminder () {
      var saveNote = {
        note: this.reminder,
        coacheeUuid: this.uuid,
        reminderDate: this.reminderDate,
        type: 'reminder'
      }
      this.showReminderWarning = false
      var today = new Date()
      var reminderDateTemp = new Date(this.reminderDate)
      if (reminderDateTemp.getTime() <= today.getTime()) {
        this.showReminderWarning = true
      }
      this.loadSaveNote(saveNote).then(res => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Reminder Successfully Saved!'
        })
      })
    },
    clearReminder () {
      this.reminder = ''
      this.reminderDate = ''
      this.showReminderWarning = false
      var saveNote = {
        note: '',
        coacheeUuid: this.uuid,
        reminderDate: '',
        type: 'reminder'
      }
      this.loadSaveNote(saveNote).then(res => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Reminder Successfully Cleared!'
        })
      })
    },
    changeMillisToDate (selected) {
      if (selected) {
        return DateTime.fromMillis(selected, {zone: 'utc'}).toFormat('MM/dd/yyyy')
      }
      return null
    }
  },

  computed: {
    ...mapState({
    })
  },

  watch: {
  }
}
</script>

<style>
    .display-block {
      display: block!important;
    }

    @media (min-width: 900px) {
        .modal .modal-xlg {
            max-width: 80% !important;
            width: 80% !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/app/coacheeTracker/components/CoacheeDetail.vue